import React from 'react';

import PageLayout from '../../../components/PageLayout';

import AppDev from './AppDev';

async function action() {
  return {
    title: 'Web & Mobile App Development',
    description:
      'Build robust software that works for your business. Having software that consistently works is the best way to build up trust in your brand.',
    chunks: ['app-dev'],
    component: (
      <PageLayout>
        <AppDev />
      </PageLayout>
    ),
  };
}

export default action;
